import"../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as l}from"../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{illustration as t}from"../../illustration-registry.js";const p=t("small-business",l`
        <svg width="168" height="168" viewBox="0 0 168 168" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3736_600)">
            <g style="mix-blend-mode:multiply">
            <path d="M141.12 132.72L141.12 105.746L27.5641 105.746L27.5641 132.72L141.12 132.72Z" fill="#FABA00"/>
            </g>
            <g style="mix-blend-mode:multiply">
            <path d="M98.0235 105.746C98.0235 82.5453 117.012 63.7374 140.436 63.7374L140.436 35.28C101.144 35.28 69.2925 66.8287 69.2924 105.746L98.0235 105.746Z" fill="#8EDB7A"/>
            </g>
            <g style="mix-blend-mode:multiply">
            <path d="M69.2925 105.746C69.2925 82.5453 50.3038 63.7374 26.88 63.7374L26.88 35.28C66.1715 35.28 98.0235 66.8287 98.0235 105.746L69.2925 105.746Z" fill="#17A9DC"/>
            </g>
            </g>
            <defs>
            <clipPath id="clip0_3736_600">
            <rect width="116" height="98" fill="white" transform="translate(26 35)"/>
            </clipPath>
            </defs>
        </svg>
    `);export{p as SmallBusiness};
